import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Studio from "@/pages/Studio";
import FreehandStudio from "@/pages/FreehandStudio";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, AuthCallback } from "@/lib/auth";
import { PaymentSuccess } from "@/components/studio/UpgradeDialog";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes('session_id=')) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Studio />} />
      <Route path="/draw" element={<FreehandStudio />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<Studio />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-[#F8F9FA] text-slate-900">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster position="bottom-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
